module.exports = __webpack_public_path__ + "static/media/Heebo-Medium.0180f346.woff";